export default __webpack_public_path__ + "static/media/contact_banner_bg.82827a83.jpg";